import React, { Component } from 'react';

import localizacao from '../assets/localizacao.jpg';


class PageLocalizacao extends Component {
  render() {
    return(    
        <div id="body">
          <h1 id="body-h1"> Localização</h1>
          <p>
            Empresarial José Cirilo<br/>
            Rodovia Raposo Tavares, km 558,5<br/>
            Distrito de Espigão<br/>
            Regente Feijó - SP<br/>
            CEP: 19575-000
          </p><br/><br/>
          <div id="div-img-localizacao">
            <img src={localizacao} />
          </div>
          <br/><br/>
          <p className="center">
            <a href="https://www.google.com.br/maps/@-22.1571799,-51.338423,12.71z">Click aqui Para Ver o Mapa</a>
          </p>
        </div>
    );
  }
}

export default PageLocalizacao;



// WEBPACK FOOTER //
// ./src/Pages/PageLocalizacao.js